import { useUpsertGoalsMutation } from '@mote/api'

/**
 * @typedef {Object} GoalsItemProps
 * @property {(e: MouseEvent) => void} onUpdateSuccess
 * @property {string} goalName
 * @property {GoalStatus} goalStatus
 * @property {string} text
 */

/**
 * @param {GoalsItemProps} props
 * @return {JSX.Element}
 * @constructor
 */
export function GoalsItem(props) {
  const { mutate: upsertGoalsMutate } = useUpsertGoalsMutation()

  return (
    <div>
      <a
        href='/'
        onClick={e => {
          e.preventDefault()
          upsertGoalsMutate({
            variables: {
              goalStatus: props.goalStatus,
              goalName: props.goalName
            }
          }).then(() => props.onUpdateSuccess(e))
        }}
      >
        {props.text} (by setting goals.{props.goalName} to "{props.goalStatus}")
      </a>
    </div>
  )
}
